import { render, staticRenderFns } from "./PharmaceuticProfileComponent.vue?vue&type=template&id=740d8956&scoped=true&"
import script from "./PharmaceuticProfileComponent.vue?vue&type=script&lang=js&"
export * from "./PharmaceuticProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./PharmaceuticProfileComponent.vue?vue&type=style&index=0&id=740d8956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d8956",
  null
  
)

export default component.exports